import { StyledComponent } from '@emotion/styled';
import { alpha, styled } from '@mui/material';
import { DatePicker, DatePickerProps, DatePickerSlotProps } from '@mui/x-date-pickers';
import { RefAttributes } from 'react';
import { RookeryRegularFont } from 'v3/styles/common';

export const DatePickerStyled: StyledComponent<DatePickerProps & RefAttributes<HTMLDivElement>> = styled(DatePicker)(
  ({ theme }) => ({
    width: '100%',
    height: '3rem',
    justifyContent: 'center',
    border: 'none',
    borderBottom: `.1rem solid ${theme.palette.secondary.light}`,

    input: {
      font: `400 1rem ${RookeryRegularFont}`,
      color: theme.palette.common.white,

      '&::placeholder': {
        color: alpha(theme.palette.common.white, 0.38),
      },
    },

    fieldset: { border: 'none' },

    '& .MuiInputLabel-root.Mui-focused,& .MuiFormLabel-root': {
      color: `${alpha(theme.palette.common.white, 0.6)} `,
    },

    '& .MuiPickersInputBase-root': {
      color: `${alpha(theme.palette.common.white, 1)}`,
    },

    '& .MuiInputAdornment-root button': {
      color: alpha(theme.palette.common.white, 0.54),
    },

    '&:is(:focus-within)': {
      borderBottom: 'double .2rem transparent',
      backgroundImage: `${theme.palette.gradient[500]}, ${theme.palette.gradient[100]}`,
      backgroundRepeat: 'no-repeat',
      backgroundOrigin: 'border-box',
      backgroundSize: '100% 9%',
      backgroundClip: 'padding-box, border-box',
      backgroundPosition: 'bottom',
    },
  }),
);

export const slotProps: DatePickerSlotProps<boolean> = {
  mobilePaper: {
    sx: (theme) => ({
      '& .MuiDialogContent-root': {
        backgroundColor: theme.palette.primary.main,
      },
      '& .MuiTypography-root, & .MuiPickersCalendarHeader-root, & .MuiButtonBase-root': {
        color: theme.palette.common.white,
      },
      color: theme.palette.common.white,
      borderRadius: '1.25rem',
      [theme.breakpoints.up('lg')]: {
        width: '25rem',
      },
    }),
  },

  day: {
    sx: (theme) => ({
      color: theme.palette.common.white,
      '&.MuiPickersDay-root': {
        '&.Mui-selected': {
          backgroundColor: theme.palette.details.dark,
          color: theme.palette.common.white,
        },
        '&.Mui-disabled': {
          color: alpha(theme.palette.common.white, 0.4),
          backgroundColor: alpha(theme.palette.secondary.light, 0.1),
        },
      },
      '&.MuiPickersDay-today': {
        borderColor: theme.palette.common.white,
      },
    }),
  },
};
